export const css = (...args: (string | boolean | undefined)[]) =>
    args.filter(s => s !== '' && !!s).join(' ');